import Icon from "@mui/icons-material/Settings";
import YearlyNiyaazSettingsPage from "./YearlyNiyaazSettingsPage";

export default {
  list: YearlyNiyaazSettingsPage,
  icon: Icon,
  label: "Settings",
  options: { label: "Settings" },
  name: "yearlyNiyaazSettings",
};
